//
import React from 'react';
import events from 'events';
import Component from '../core/component';

// 工具
import tools from '../libs/tools';
// 组件
import Loading from '../mobile/loading';
import Alert from './alert';
import Confirm from './confirm';
//import Language from '../common/language';
import Modal from './modal';
import Router from '../router/router';
import Toast from '../mobile/toast';

const register = {};
events.defaultMaxListeners = 1000;


/**
 *
 */
class App extends Component {

    eventNames = [
        'Loading',
        "Popup",
        "Alert",
        'Modal',
        "Picker",
        "Router",
        "Response",
        "System"
    ];
    state = {};


    /**
     *
     * @param name
     * @param route
     */
    static register(name, route) {
        if (!register[name]) {
            register[name] = route;
        }
    };

    /**
     *
     * @param props
     * @param context
     * @param queue
     */
    constructor(props, context, queue) {
        super(props, context, queue);
        window.appContext = this.events;

    }

    /**
     *shouldComponentUpdate(object nextProps, object nextState): boolean
     * 当组件做出是否要更新DOM的决定的时候被调用。
     * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
     * 如果不需要React更新DOM，则返回false。
     */
    //shouldComponentUpdate(nextProps, nextState) {
    //}


    /**
     * 挂载发生之前立即被调用
     */
    //componentWillMount() {
    //}

    /**
     * 在挂载结束之后马上被调用
     */
    componentDidMount() {
        //this.events.addListener('Response', this.handlerResponse);
        this._on('Response', this.handlerResponse);
        this.app.addEventListener('touchmove', function (e) {
            e.preventDefault(); //阻止默认事件(上下滑动)
        }, {passive: false}) //passive防止阻止默认事件不生效

        ;(/iphone|ipod|ipad/i.test(navigator.appVersion)) && document.addEventListener('blur', (e) => {
            if (['input', 'textarea', 'select'].includes(e.target.localName)) {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    document.body.scrollIntoView(false)
                }, 400)
            }
        }, true)

    }

    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    //componentWillUnmount() {
    //}


    /**
     *
     * @return {*}
     */
    render() {
        return (
            <div className="c-app" ref={ref => this.app = ref}>
                <Loading show={false}/>
                <Alert/>
                <Confirm/>
                <Modal/>
                <Toast/>
                <div className="c-app-pages">
                    {this.props.children}
                </div>
            </div>
        );
    }

    handlerResponse = (key, val) => {
        if (register[key]) {
            register[key](val);
        }
    }
}

//App = Enhance(App, {}, 'App');
App.displayName = "App"
export default App;
